import { PureConnect, React } from '../../react';

import selectors from './selectors';

import SELECTION_RESET from './actions/RESET';
import SELECTION_SUCCESS from './actions/SUCCESS';

import cx from './style.less';
import { Btn } from '../../react-toolbox-redesign/button';

export default PureConnect('NoteSelectionSave')(
    (state) => ({
        selection: selectors.selection(state),
        isnote: selectors.isnote(state),
        valid: !!state.selection.selection,
        visible: state.selection.creating,
        origin: state.notemenu.origin,
        buttonNo: state.notemenu.buttonNo,
    }),
    (dispatch) => ({
        onCancel: () => { dispatch(SELECTION_RESET({ })); },
        onComplete: (start: string, end: string, isnote: boolean) => dispatch(SELECTION_SUCCESS({ start, end, isnote })),
    }),
    ({ visible, valid, selection, isnote, onCancel, onComplete }) => {
        
        return (
            <div className={cx('buttons-container',(!visible) ? 'wcag-invisible' : '')}  
                    aria-hidden={!visible} 
                    aria-labelledby= "Selectbuttons">
                     {/* * WCAG (button):
                    1) no role; they are buttons
                    2) focussable (Tab)
                    3) toggle function: n/a (when true use aria-pressed)
                    4) aria-expanded: yes/no
                    5) aria-haspopup: yes
                    6) aria-labelledby/aria-describedby: ref to label
                    7) icon of button is explained by tekst-> aria-hidden       */}
                    
                    <Btn 
                        type="button" 
                        className={cx('btn','secondary-btn')} 
                        // extraClassNames={['secondary-btn']} 
                        aria-label={'Annuleren'}
                        aria-haspopup={false}                        
                        tabIndex={0}                                                              
                            onClick={()=> onCancel()}
                        >
                            <span>ANNULEREN</span>
                    </Btn>
                    <Btn 
                        type="button" 
                        className={'btn'} 
                        aria-label={'Bevestigen'}
                        aria-haspopup={false}    
                        disabled={!valid}
                        tabIndex={0}                                                              
                            onClick={()=> onComplete(selection.start, selection.end, isnote)}
                        >
                            <span>BEVESTIGEN</span>
                    </Btn>                    
            </div>
        );
    },
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/selection/selectionsave.tsx